export default __webpack_public_path__ + "static/media/aix-provence-station.6eb02a80.webp";